import { generateTestId } from "@client-shared";

export const setPreferencesViewTestId = (identifier: string): string =>
  generateTestId("PreferencesView", identifier);

export const setPreferencesViewContainerTestId = (): string =>
  setPreferencesViewTestId("container");

export const setPreferencesViewTitleTestId = (): string =>
  setPreferencesViewTestId("title");

export const setPreferencesViewDescriptionTestId = (): string =>
  setPreferencesViewTestId("description");

export const setPreferencesViewRoasterInfoCardTestId = (): string =>
  setPreferencesViewTestId("roaster-info-card");

export const setPreferencesViewRoasterInfoTitleTestId = (): string =>
  setPreferencesViewTestId("roaster-info-title");

export const setPreferencesViewRoasterInfoDescriptionTestId = (): string =>
  setPreferencesViewTestId("roaster-info-description");

export const setPreferencesViewBillingAddressCardTestId = (): string =>
  setPreferencesViewTestId("billing-address-card");

export const setPreferencesViewBillingAddressTitleTestId = (): string =>
  setPreferencesViewTestId("billing-address-title");

export const setPreferencesViewBillingAddressDescriptionTestId = (): string =>
  setPreferencesViewTestId("billing-address-description");

export const setPreferencesViewShippingAddressCardTestId = (): string =>
  setPreferencesViewTestId("shipping-address-card");

export const setPreferencesViewShippingAddressTitleTestId = (): string =>
  setPreferencesViewTestId("shipping-address-title");

export const setPreferencesViewShippingAddressDescriptionTestId = (): string =>
  setPreferencesViewTestId("shipping-address-description");

export const setPreferencesViewProfileInfoCardTestId = (): string =>
  setPreferencesViewTestId("profile-info-card");

export const setPreferencesViewProfileInfoTitleTestId = (): string =>
  setPreferencesViewTestId("profile-info-title");

export const setPreferencesViewProfileInfoDescriptionTestId = (): string =>
  setPreferencesViewTestId("profile-info-description");

export const setPreferencesViewPersonaCardTestId = (): string =>
  setPreferencesViewTestId("persona-card");

export const setPreferencesViewPersonaTitleTestId = (): string =>
  setPreferencesViewTestId("persona-title");

export const setPreferencesViewPersonaDescriptionTestId = (): string =>
  setPreferencesViewTestId("persona-description");

export const setPreferencesViewLogoSectionTestId = (): string =>
  setPreferencesViewTestId("logo-section");

export const setPreferencesViewChooseFileButtonTestId = (): string =>
  setPreferencesViewTestId("choose-file-button");

export const setPreferencesViewSaveChangesButtonTestId = (): string =>
  setPreferencesViewTestId("save-changes-button");

export const setPreferencesViewSameAsBillingToggleTestId = (): string =>
  setPreferencesViewTestId("same-as-billing-toggle");
